<template>
  <component :is="determinedComponent" />
</template>

<script>
import ChurnPreventionSuccess from "@/pages/success-page/components/churn-prevention/index"
import JoinOrganisationSuccess from "@/pages/success-page/components/join-organisation/index"
import JoinedConnect from "@/pages/success-page/components/joined-connect/index"
import JoinedSpace from "@/pages/success-page/components/joined-space/index"
import Go1AccountConnected from "@/pages/success-page/components/go1-account-connected/index"
import TeamPurchaseSuccess from "@/pages/success-page/components/team-purchase/index"
import ConfirmEmailSuccess from "@/pages/success-page/components/confirm-email/index"
import PurchaseSuccess from "@/pages/success-page/components/purchase/index"
import UpgradeSuccess from "@/pages/success-page/components/upgrade/index"
import GiftcardRedeemed from "@/pages/success-page/components/giftcard-redeemed/index.vue";
import PlatinumSuccess from "@/pages/success-page/components/platinum/index"
import { getSearchParam } from "@/utils/location"

export default {
  name: "SuccessPageController",
  computed: {
    determinedType() {
      if (getSearchParam("type")) {
        return getSearchParam("type")
      } else {
        return ""
      }
    },
    determinedComponent() {
      switch (this.determinedType) {
        case "stay":
          return ChurnPreventionSuccess
        case "business":
          return TeamPurchaseSuccess
        case "confirmEmail":
          return ConfirmEmailSuccess
        case "purchase":
          return PurchaseSuccess
        case "joinedOrganisation":
          return JoinOrganisationSuccess
        case "joinedConnect":
          return JoinedConnect
        case "joinedSpace":
          return JoinedSpace
        case "go1AccountConnected":
          return Go1AccountConnected
        case "upgrade":
          return UpgradeSuccess
        case "giftcardRedeemed":
          return GiftcardRedeemed
        case "platinum":
          return PlatinumSuccess
        default:
          return null
      }
    }
  }
}
</script>
